var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60308 12.336H3.75291C2.32724 12.336 1.16699 11.1758 1.16699 9.74896V3.25704C1.16699 1.83021 2.32724 0.669373 3.75291 0.669373H6.59666C8.02349 0.669373 9.18433 1.83021 9.18433 3.25704V3.80071C9.18433 4.04221 8.98833 4.23821 8.74683 4.23821C8.50533 4.23821 8.30933 4.04221 8.30933 3.80071V3.25704C8.30933 2.31204 7.54108 1.54437 6.59666 1.54437H3.75291C2.80966 1.54437 2.04199 2.31204 2.04199 3.25704V9.74896C2.04199 10.6934 2.80966 11.461 3.75291 11.461H6.60308C7.54341 11.461 8.30933 10.6957 8.30933 9.75537V9.20529C8.30933 8.96379 8.50533 8.76779 8.74683 8.76779C8.98833 8.76779 9.18433 8.96379 9.18433 9.20529V9.75537C9.18433 11.1787 8.02583 12.336 6.60308 12.336ZM11.6502 6.94021H5.68538C5.44388 6.94021 5.24788 6.74421 5.24788 6.50271C5.24788 6.26121 5.44388 6.06521 5.68538 6.06521H11.65L10.6929 5.11204C10.522 4.94171 10.5208 4.66521 10.6917 4.49371C10.8621 4.32221 11.1386 4.32221 11.3101 4.49254L13.0118 6.18676C13.0182 6.19288 13.0244 6.19919 13.0304 6.20569C13.1055 6.28606 13.147 6.39254 13.147 6.50271C13.147 6.61333 13.1051 6.72024 13.0295 6.80073C13.0238 6.80685 13.0179 6.8128 13.0119 6.81858L11.3101 8.51346C11.2249 8.59862 11.1129 8.64121 11.0015 8.64121C10.8895 8.64121 10.7769 8.59862 10.6917 8.51229C10.5214 8.34079 10.522 8.06429 10.6929 7.89396L11.6502 6.94021Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.73b8ad72b78ea46f41f44635ff1fb8ba.svg";
export { ForwardRef as ReactComponent };